module.exports = __webpack_public_path__ + "static/media/preview-twitter-disabled.b29e83cb.svg";